export default function createSessionStoragePlugin({
  moduleName,
  storageKey,
}) {
  return (store) => {
    // 1) Rehidrata el módulo desde sessionStorage al arrancar la app.
    // Se aplica solo al módulo configurado (moduleName).
    const sessionState = sessionStorage.getItem(storageKey);
    if (sessionState !== null) {
      const persistedModuleState = JSON.parse(sessionState);
      const initialModuleState = store.state[moduleName] || {};
      // Sanea el estado persistido para evitar arrastrar claves obsoletas
      // cuando cambia la forma del módulo entre versiones.
      const sanitizedModuleState = Object.keys(
        initialModuleState
      ).reduce((acc, key) => {
        acc[key] =
          persistedModuleState &&
          Object.prototype.hasOwnProperty.call(
            persistedModuleState,
            key
          )
            ? persistedModuleState[key]
            : initialModuleState[key];
        return acc;
      }, {});

      store.replaceState({
        ...store.state,
        // Solo sustituye el módulo objetivo; el resto del store se conserva.
        [moduleName]: sanitizedModuleState,
      });
    }

    store.subscribe((mutation, state) => {
      // 2) Persiste el módulo en cada mutación namespaced de ese módulo.
      // Ejemplo: "agroIA/pushMessage", "agroIA/setShowChatPopup", etc.
      if (mutation.type.startsWith(`${moduleName}/`)) {
        sessionStorage.setItem(
          storageKey,
          JSON.stringify(state[moduleName])
        );
      }
    });
  };
}
